module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Matt Brolly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Following his law degree where he developed an interest in criminal law, Matt completed his Masters in Creative Writing at Glasgow University. He reads widely across all genres, and lives in London with his wife and their two young children.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BUCjX6/tc-custom/9781911420439.jpg?1731013571968",
      "alt": "This image is the cover for the book Dead Embers, DCI Michael Lambert"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dead Embers, DCI Michael Lambert\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In this crime thriller, a British DCI investigates a fire and a shocking double murder, while his own life is just as explosive. ")])]), _c('p', [_vm._v(" When DCI Michael Lambert is called out to an apparent house fire, he knows it can’t be routine. Instead, he finds the remains of a burnt house, a traumatized child, and two corpses—one of whom is a senior police officer. ")]), _c('p', [_vm._v(" Lambert’s got other problems. Anti-corruption are onto his boss. His relationship is on the rocks. He can’t get over his ex-wife—and he keeps blacking out. ")]), _c('p', [_c('i', [_vm._v("But when a detective has been murdered, the stakes are too high to get distracted. All is not as it seems. As the investigation continues Lambert realizes he is getting drawn into something altogether bigger and more terrifying than he could ever have imagined . . .")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Digital Publishing Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0